export enum SectionType {
  Banner,
  Store,
  Promo,
  Text,
  Tile,
  RecentSearch,
  HotelPromo
}

export const SECTION_TYPE_NAME = {
  Banner: 'BANNER',
  Store: 'STORE',
  Promo: 'PROMO',
  Text: 'TEXT',
  Tile: 'TILE',
  RecentSearch: 'RECENT SEARCH',
  HotelPromo: 'HOTEL PROMOS'
};

